import React from 'react';
import './css/loader.css';

const Loader: React.FC = () => {
    return (
        <div className="loader-container">
            <div className="loader-content">
                <img 
                    src="/images/wfc/wfc-nike-lusso-logo.png" 
                    alt="WFC Nike Lusso" 
                    className="loader-logo"
                />
            </div>
        </div>
    );
};

export default Loader;
